import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_AUDIENCES_QUERY_KEY } from './useGetAudiences';

import AudiencesService, {
  GenerateEmailTemplateDto,
} from '@/services/AudiencesService';

export function useStrategyGenerateEmailTemplate() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (generateEmailTemplateDto: GenerateEmailTemplateDto) =>
      AudiencesService.generateEmailTemplate(generateEmailTemplateDto),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: GET_AUDIENCES_QUERY_KEY,
      });
    },
  });

  return {
    generateEmailTemplate: mutateAsync,
    isLoading: isPending,
  };
}
